import "../i18n.mjs";
import { useTrImageCategory as e } from "./useTrImageCategory.mjs";
import { useCallback as t } from "react";
import { useTranslation as n } from "react-i18next";
import { isSpacedCategory as r } from "@maat/api-main/types";
//#region src/enums/usePhotoSectionLabel.ts
var i = () => {
	let { t: i } = n("enums"), a = e();
	return t((e, t) => typeof t != "number" || !r(e) ? a(e) : i(`imageCategorySpace.${e}`, {
		index: t,
		defaultValue: a(e)
	}), [i, a]);
};
//#endregion
export { i as usePhotoSectionLabel };
